import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_filter_bar = _resolveComponent("oss-filter-bar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isAuthorized)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "my-3 justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.miscellaneousOperationDialog = true)),
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("Ajouter")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '6',
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_filter_bar, {
                    mode: 'bankTransaction',
                    type: _ctx.type,
                    "onUpdate:type": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                    showTypeTag: false,
                    text: _ctx.search,
                    "onUpdate:text": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                    startDate: _ctx.beginDate,
                    "onUpdate:startDate": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.beginDate) = $event)),
                    endDate: _ctx.endDate,
                    "onUpdate:endDate": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                    minDate: _ctx.minDate,
                    maxDate: _ctx.maxDate,
                    dateIsManadatory: true,
                    status: _ctx.reconciliationStatus,
                    "onUpdate:status": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reconciliationStatus) = $event)),
                    minPrice: _ctx.minAmount,
                    "onUpdate:minPrice": _cache[6] || (_cache[6] = ($event: any) => (_ctx.minAmount = $event + '')),
                    maxPrice: _ctx.maxAmount,
                    "onUpdate:maxPrice": _cache[7] || (_cache[7] = ($event: any) => (_ctx.maxAmount = $event + '')),
                    payBy: _ctx.payBy,
                    "onUpdate:payBy": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payBy) = $event)),
                    limitMinPrice: _ctx.limitMinAmount,
                    limitMaxPrice: _ctx.limitMaxAmount,
                    "types-list": 
                            _ctx.documentTypes.map((type) => {
                                return { value: type, text: _ctx.$t('document.type.' + type) };
                            })
                        ,
                    "status-list": 
                            _ctx.allReconciliationStatus.map((status) => {
                                return { value: status, text: _ctx.formatStatus(status) };
                            })
                        ,
                    payByList: _ctx.payByList,
                    companyId: _ctx.selectedCompany.id
                  }, null, 8, ["type", "text", "startDate", "endDate", "minDate", "maxDate", "status", "minPrice", "maxPrice", "payBy", "limitMinPrice", "limitMaxPrice", "types-list", "status-list", "payByList", "companyId"])
                ]),
                _: 1
              }, 8, ["cols"]),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    outlined: "",
                    readonly: "",
                    "model-value": 'Debit : ' + _ctx.newCommonFormatCurrency(_ctx.totalDebit, undefined),
                    density: "compact"
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    outlined: "",
                    readonly: "",
                    "model-value": 'Crédit : ' + _ctx.newCommonFormatCurrency(_ctx.totalCredit, undefined),
                    density: "compact"
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_oss_data_table, {
            headers: _ctx.headers,
            items: _ctx.items,
            page: _ctx.pagination.page,
            "onUpdate:page": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pagination.page) = $event)),
            "sort-by": _ctx.sortBy,
            "onUpdate:sortBy": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sortBy) = $event)),
            "sort-desc": _ctx.pagination.descending,
            "onUpdate:sortDesc": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pagination.descending) = $event)),
            "items-length": _ctx.pagination.totalItems,
            "items-per-page": _ctx.pagination.rowsPerPage,
            "onUpdate:itemsPerPage": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
            "items-per-page-options": [5, 10, 25],
            loading: _ctx.loading,
            "onUpdate:loading": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.loading) = $event)),
            class: "table",
            "hide-default-footer": "",
            "fixed-header": "",
            height: "71vh",
            style: {"border-collapse":"collapse"}
          }, {
            "no-data": _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("Aucune écriture trouvée")
            ])),
            item: _withCtx((props) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.accountingLines, (al, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  style: {"cursor":"pointer"},
                  "data-cy": "accountingLog-document",
                  key: props.item.id + '_' + index,
                  onClick: ($event: any) => (_ctx.onItemClick(props.item))
                }, [
                  _createElementVNode("td", {
                    class: "px-0 text-center",
                    style: _normalizeStyle(_ctx.getCellStyle(index))
                  }, _toDisplayString(_ctx.formatDate(al.date)), 5),
                  _createElementVNode("td", {
                    class: "pl-2 pr-2 text-left",
                    style: _normalizeStyle(_ctx.getCellStyle(index))
                  }, _toDisplayString(_ctx.getAccountableAccountTitle(al)), 5),
                  _createElementVNode("td", {
                    style: _normalizeStyle(_ctx.getCellStyle(index))
                  }, [
                    (al.tag)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          label: "",
                          color: "tagFree",
                          class: "mr-1",
                          size: "x-small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(al.tag.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (al.tags)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(al.tags, (tag, tagIndex) => {
                          return (_openBlock(), _createBlock(_component_v_chip, {
                            label: "",
                            class: "mr-1",
                            key: tagIndex,
                            size: "x-small"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                style: _normalizeStyle('color:' + _ctx.labelTextColor + ';')
                              }, _toDisplayString(tag.name), 5)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(al.wording), 1)
                  ], 4),
                  _createElementVNode("td", {
                    class: "text-left",
                    style: _normalizeStyle(_ctx.getCellStyle(index))
                  }, _toDisplayString(_ctx.getThirdPartyName(al)), 5),
                  _createElementVNode("td", {
                    class: "px-0 text-right",
                    style: _normalizeStyle(_ctx.getCellStyle(index))
                  }, [
                    (al.amountSigned > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.newCommonFormatCurrency(Math.abs(al.amountSigned), undefined)), 1))
                      : _createCommentVNode("", true)
                  ], 4),
                  _createElementVNode("td", {
                    class: "pl-0 pr-2 text-right",
                    style: _normalizeStyle(_ctx.getCellStyle(index))
                  }, [
                    (al.amountSigned < 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.newCommonFormatCurrency(Math.abs(al.amountSigned), undefined)), 1))
                      : _createCommentVNode("", true)
                  ], 4)
                ], 8, _hoisted_1))
              }), 128))
            ]),
            _: 1
          }, 8, ["headers", "items", "page", "sort-by", "sort-desc", "items-length", "items-per-page", "loading"]),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.miscellaneousOperationDialog,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
            actions: _ctx.actionsMiscellaneousOperation,
            width: "90vw"
          }, {
            default: _withCtx(() => [
              (_ctx.miscellaneousOperationDialog)
                ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                    key: 0,
                    companyId: _ctx.selectedCompany.id,
                    actions: _ctx.actionsMiscellaneousOperation,
                    onUpsert: _cache[14] || (_cache[14] = ($event: any) => (_ctx.refresh()))
                  }, null, 8, ["companyId", "actions"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "actions"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}